const feathers = require('@feathersjs/feathers');
const rest = require('@feathersjs/rest-client');
const auth = require('@feathersjs/authentication-client');

const app = feathers();

// Connect to the same as the browser URL (only in the browser)
// const restClient = rest();

// Connect to a different URL
const restClient = rest(`${window.env.API_URL}`)

// Configure an AJAX library (see below) with that client 
app.configure(restClient.fetch(window.fetch));
app.configure(auth({
    storage: window.localStorage,
    storageKey: 'auth',
    path: 'authentication'
}));

export default app;

// Connect to the `http://feathers-api.com/messages` service
//const messages = app.service('scheduleRequests');